import React, { useRef, useState } from "react";
import { Button, Modal, Spin } from "..";

export default function Google2FAModal({
  onSubmit,
  visible,
  onCancel,
  isLoading,
}) {
  const [pin, setPin] = useState(Array(6).fill(""));
  const inputRefs = useRef([...Array(6)].map(() => React.createRef()));

  const handleChange = (index, value) => {
    if (isNaN(value)) return; // Only allow numbers
    console.log(index);

    const newPin = [...pin];
    newPin[index] = value;
    setPin(newPin);

    // Move to next input if value is entered
    if (value !== "" && index < 5) {
      inputRefs.current[index + 1].current.focus();
    }

    if (index == 5 && isNaN(pin[5])) {
      const newPin = Array(6).fill("");
      setPin(newPin);
      inputRefs.current[0].current.focus();
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pasteData = e.clipboardData
      .getData("Text")
      .replace(/\D/g, "")
      .slice(0, 6);
    if (!pasteData) return;

    const newPin = [...pin];
    pasteData.split("").forEach((char, i) => {
      newPin[i] = char;
    });
    setPin(newPin);

    inputRefs.current[
      pasteData.length >= 6 ? 5 : pasteData.length
    ]?.current?.focus();
  };

  const handleKeyDown = (index, e) => {
    // Move to previous input on backspace if current input is empty
    if (e.key === "Backspace" && !pin[index] && index > 0) {
      inputRefs.current[index - 1].current.focus();
    }
  };

  return (
    <Modal visible={visible} onCancel={onCancel}>
      <div className="manara-page-reset-pin">
        <h5>Type your 6-digit PIN below</h5>
        <div
          style={{
            display: "flex",
            gap: "8px",
            justifyContent: "center",
            margin: "20px 0",
          }}
        >
          {[...Array(6)].map((_, index) => (
            <input
              key={index}
              type="text"
              maxLength={1}
              value={pin[index]}
              ref={inputRefs.current[index]}
              onChange={(e) => handleChange(index, e.target.value)}
              onKeyDown={(e) => handleKeyDown(index, e)}
              style={{
                width: "40px",
                height: "40px",
                fontSize: "24px",
                textAlign: "center",
                border: "1px solid #rgb(10, 186, 181)",
                borderRadius: "8px",
                outline: "none",
                background: "#ffffff",
                color: '#c3ac5f'
              }}
              onPaste={handlePaste}
            />
          ))}
        </div>
        <div
          className="change-button"
          style={{ display: "flex", justifyContent: "center" }}
        >
          <Button onClick={() => onSubmit(pin.join(""))}>
            {isLoading ? <Spin spinning={true} /> : "Confirm"}
          </Button>
        </div>
      </div>
    </Modal>
  );
}
